import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  readSearchParam,
  replaceSearchParam,
} from 'js/components/Charts/chart-search';

/**
 * Query-string value updated with history.replace so changes do not add a
 * history entry.
 */
export function useSearchParam(paramName) {
  const history = useHistory();
  const location = useLocation();
  const value = useMemo(
    () => readSearchParam(location.search, paramName),
    [location.search, paramName]
  );

  const setValue = useCallback(
    (next) => {
      if (next == null || next === value) {
        return;
      }
      const search = replaceSearchParam(location.search, paramName, next);
      if (search === (location.search || '')) {
        return;
      }
      history.replace({
        pathname: location.pathname,
        search,
        hash: location.hash,
        state: { ...(location.state || {}), noScroll: true },
      });
    },
    [
      history,
      location.hash,
      location.pathname,
      location.search,
      location.state,
      paramName,
      value,
    ]
  );

  return [value, setValue];
}
